module.exports = __webpack_public_path__ + "static/index-7fb7e6704d635ba029f15ab8a2197a54.png";